import { render } from "./clean_new.vue?vue&type=template&id=1fc15a02&scoped=true"
import script from "./clean_new.vue?vue&type=script&lang=js"
export * from "./clean_new.vue?vue&type=script&lang=js"

import "./clean_new.vue?vue&type=style&index=0&id=1fc15a02&lang=scss&scoped=scoped"
import "./clean_new.vue?vue&type=style&index=1&id=1fc15a02&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc15a02"]])

export default __exports__